import React from 'react';
import { useAuthContext } from '@/hooks/useAuthContext';
import { RoleDashboard } from '@/components/dashboard';

export default function Dashboard() {
  const { user } = useAuthContext();

  if (!user) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-neutral-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return <RoleDashboard role={user.role} />;
}
